import styled from "styled-components";

export const InputStyle = styled.div`
  .react-datepicker-wrapper,
  .react-datepicker__input-container {
    display: block !important;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DatePicker/style.js